module.exports = __webpack_public_path__ + "static/media/covid_web.e0995c3d.PNG";